import { string, struct } from 'io-ts/Decoder';

import {
	Id,
	WholeHouseFoundationId,
	WholeHouseFoundationBasementId,
	WholeHouseFramingId,
	WholeHouseDecksAndPorchesId,
	WholeHouseExteriorFinishesId,
	WholeHouseEwpFloorRoofLayoutId,
	WholeHouseInteriorFinishesId,
	WholeHouseDimensionalFloorRoofLayoutId,
	WholeHouseOpeningsId,
	WholeHouseRoofingId,
	WholeHouseFlatRoofingId,
} from './Id';

export const WholeHouseFoundationRefItem = struct({
	id: WholeHouseFoundationId,
	name: string,
});

export const WholeHouseFoundationBasementRefItem = struct({
	id: WholeHouseFoundationBasementId,
	name: string,
});

export const WholeHouseFramingRefItem = struct({
	id: WholeHouseFramingId,
	name: string,
});

export const WholeHouseDecksAndPorchesRefItem = struct({
	id: WholeHouseDecksAndPorchesId,
	name: string,
});

export const WholeHouseExteriorFinishesRefItem = struct({
	id: WholeHouseExteriorFinishesId,
	name: string,
});

export const WholeHouseEwpFloorRoofLayoutRefItem = struct({
	id: WholeHouseEwpFloorRoofLayoutId,
	name: string,
});

export const WholeHouseInteriorFinishesRefItem = struct({
	id: WholeHouseInteriorFinishesId,
	name: string,
});

export const WholeHouseDimensionalFloorRoofLayoutRefItem = struct({
	id: WholeHouseDimensionalFloorRoofLayoutId,
	name: string,
});

export const WholeHouseOpeningsRefItem = struct({
	id: WholeHouseOpeningsId,
	name: string,
});

export const WholeHouseRoofingRefItem = struct({
	id: WholeHouseRoofingId,
	name: string,
});

export const WholeHouseFlatRoofingRefItem = struct({
	id: WholeHouseFlatRoofingId,
	name: string,
});

export const RefItem = struct({
	id: Id,
	name: string,
});
